import { render, staticRenderFns } from "./update-status-dialog.vue?vue&type=template&id=10541820&"
import script from "./update-status-dialog.vue?vue&type=script&lang=js&"
export * from "./update-status-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports